import {Box, createStyles, Grid, makeStyles, Theme, Typography} from '@material-ui/core';
import React from 'react';
import GoButtons from './GoButtons';

const useStyles = makeStyles((theme: Theme) => createStyles({
    contentProject: {
        maxWidth: 200,
        [theme.breakpoints.down('xs')]: {
            textAlign: 'left',
            margin: 'auto',
        }
    },
    projectHeading: {
        margin: theme.spacing(2),
    },
    spacer: {
        [theme.breakpoints.down('sm')]: {
            display: 'none',
        },
    },
}));

export function ColumnHeader(props: {
    column: 1 | 2 | 3 | 4;
    title: string;
}) {
    return (
        <ColumnRow>
            <ColumnBlank column={props.column} title={props.title}/>
        </ColumnRow>
    );
}

function ColumnBlank(props: {
    column: 1 | 2 | 3 | 4;
    title: string;
}) {
    const classes = useStyles();
    return (
        <Box textAlign='center' className={classes.contentProject}>
            <Typography variant="h3" component="h3">{props.title}</Typography>
        </Box>
    );
}

export function ColumnRow(props: {
    children: React.ReactElement<ColumnItemProps> | React.ReactElement<ColumnItemProps>[];
}) {
    const classes = useStyles();
    const children = React.Children.toArray(props.children) as React.ReactElement<ColumnItemProps>[];
    const items: React.ReactNode[] = [];
    let prevColumn = 0;

    children.forEach((child, index) => {
        const column = child.props.column;
        const spacer = (column - prevColumn - 1) * 3;
        if (spacer > 0) {
            items.push(<Grid key={`spacer-${index}`} item md={spacer as any} className={classes.spacer}/>);
        }
        const marginAuto = column <= 2 ? {marginRight: 'auto'} : {marginLeft: 'auto'};
        items.push(
            <Grid key={`item-${index}`} item xs={12} sm={6} md={3}>
                <Box textAlign='left' {...marginAuto}>
                    {child}
                </Box>
            </Grid>
        );
        prevColumn = column;
    });

    // Trailing spacer
    const trailing = (4 - prevColumn) * 3;
    if (trailing > 0) {
        items.push(<Grid key='spacer-trailing' item md={trailing as any} className={classes.spacer}/>);
    }

    return <React.Fragment>{items}</React.Fragment>;
}

interface ColumnItemProps {
    column: 1 | 2 | 3 | 4;
    logo?: string;
    logoAlt?: string;
    title?: string;
    header?: React.ReactNode;
    description: string;
    siteUrl?: string;
    codeUrl?: string;
    email?: string;
}

export function ColumnItem(props: ColumnItemProps) {
    const classes = useStyles();
    return (
        <Box className={classes.contentProject}>
            {props.header ? (
                <Typography variant="h5" component="h3" className={classes.projectHeading}>
                    {props.header}
                </Typography>
            ) : props.logo && props.title ? (
                <Box display='flex' alignItems='center' marginBottom={1}>
                    <img
                        className={classes.projectHeading}
                        src={props.logo}
                        alt={props.logoAlt || props.title}
                        height={45}
                    />
                    <Typography color='textPrimary' variant="h5" component="h3">{props.title}</Typography>
                </Box>
            ) : props.logo ? (
                <img
                    className={classes.projectHeading}
                    src={props.logo}
                    alt={props.logoAlt || ''}
                    height={45}
                />
            ) : null}
            <Typography variant="body1" component="div">{props.description}</Typography>
            <GoButtons
                codeUrl={props.codeUrl}
                siteUrl={props.siteUrl}
                email={props.email}
            />
        </Box>
    );
}
